// extracted by mini-css-extract-plugin
export default {"container":"SectionTitle_container__zSlOi","title":"SectionTitle_title__gZ1-f","subtitle":"SectionTitle_subtitle__Lu1ey"};